var map = {
	"./company-template.json": 150,
	"./dentist.json": 669,
	"./electrician.json": 983,
	"./gym.json": 701,
	"./kmcgroup.json": 546,
	"./nordebergentrepenadab.json": 393,
	"./plumber.json": 29,
	"./restaurant.json": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;